<template>
  <O3D>
    <slot></slot>
  </O3D>
</template>

<script>
import { O3DG2 } from '../../../Reusable/O3DG2'
import { Flame } from './Flame'
export default {
  mixins: [O3DG2],
  methods: {
    main () {
      this.sim = new Flame({ renderer: this.ctx.renderer, onLoop: this.onLoop, onResize: this.onResize, onClean: this.onClean, resX: 256, resY: 256 })
      this.o3d.add(this.sim.out.mesh)
      this.o3d.rotation.z = Math.PI * 0.5
    }
  },
  mounted () {
    this.main()
  }
}
</script>

<style>
</style>